import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_TOOLBOX_LIST = restRequest("TOOLBOX_LIST.GET_TOOLBOX_LIST");
export const SET_TOOLBOX = restRequest("TOOLBOX_LIST.SET_TOOLBOX");
export const SUBMIT_NEW_CATEGORY = restRequest(
    "TOOLBOX_LIST.SUBMIT_NEW_CATEGORY"
);
export const GET_TOOLBOXTYPE_LIST = restRequest(
    "TOOLBOX_LIST.GET_TOOLBOXTYPE_LIST"
);
export const UPLOAD_FILE = restRequest("TOOLBOX_LIST.UPLOAD_FILE");
export const SET_FILTER_TOOL_TYPE = restRequest(
    "TOOLBOX_LIST.SET_FILTER_TOOL_TYPE"
);
export const GET_NEW_TOOLBOX_UID = restRequest(
    "TOOLBOX_LIST.GET_NEW_TOOLBOX_UID"
);
export const SET_TOOLBOX_POINTS = restRequest(
    "TOOLBOX_LIST.SET_TOOLBOX_POINTS"
);
export const SET_SORT_TABLE_TYPE = "SET_SORT_TABLE_TYPE";
export const SET_SORT_TABLE_KEY = "SET_SORT_TABLE_KEY";
export const SET_SORT_TABLE_AS = "SET_SORT_TABLE_AS";
export const SET_ROW_COUNT = "SET_ROW_COUNT";
export const SET_PAGE_INDEX = "SET_PAGE_INDEX";
